<script>
  import { _ } from "../services/i18n";
  import { getRate, saveRate as apiSave } from "../services/rate";
  import { clientStore } from "../services/session";
  import { slide } from "svelte/transition";
  import { userStore } from "../services/session";
  import { alert } from "../services/stores/alert"
  import { loading  } from '../services/stores/loading';
  import HeaderHome from "../components/HeaderHome.svelte";
  import HeaderCurrentClientInfo from "../components/HeaderCurrentClientInfo.svelte";
  import { settingsHeaderLinksStore } from "../services/header";

  let previa = 1000,
    client = {};

  let factoryPrice = "",
    symbol = "",
    separator = "",
    symbolPosition = "",
    pointPvp = "";

  let region;
  $: {
    client = {
      factoryPrice,
      symbol,
      separator,
      symbolPosition,
      pointPvp
    };
    region = hasRegion();
  }

  export let isLoading;
  clientStore.subscribe(async client => {
    if(!client) return;
    try {
      isLoading = true;
      let rate = await getRate();
      if (!rate) throw "Empty rate";
      rate = rate.data;
      factoryPrice = rate.factoryPrice;
      symbol = rate.symbol.replace('&euro;','€');
      separator = rate.separator;
      symbolPosition = rate.symbolPosition.toString();
      pointPvp = rate.pointPvp;
    } catch (err) {
      console.error(err);
      alert.newAlert({
          type: "error",
          message: $_("rate_alert_errorLoad"),
          timeOut: 5000,
        })
    } finally {
      isLoading = false;
    }
  });

  const price2string = ({ price, symbol, symbolPosition, separator }) => {
    let parts = price.toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    let result = parts[0] + (separator === "." ? "," : ".") + parts[1];
    if (symbolPosition == 0) result = symbol + " " + result;
    else result = result + " " + symbol;
    return result;
  };

  const regions = {
    am: {
      symbol: "$",
      separator: ",",
      symbolPosition: "0",
    },
    eu: {
      symbol: "€",
      separator: ".",
      symbolPosition: "1",
    },
    en: {
      symbol: "£",
      separator: ",",
      symbolPosition: "0",
    },
  };

  const changeRegion = (region) => {
    return () => {
      symbol = regions[region].symbol;
      separator = regions[region].separator;
      symbolPosition = regions[region].symbolPosition;
      document
        .querySelectorAll(".but-region")
        .forEach((e) => e.classList.remove("active"));
      document.getElementById(region).classList.add("active");
    };
  };

  const hasRegion = () => {
    for (const key in regions) {
      let region = regions[key];
      let result =
        client.symbol === region.symbol &&
        client.separator === region.separator &&
        client.symbolPosition === region.symbolPosition;
      if (result) return key;
    }
    return false;
  };

  const saveRate = async () => {
    client.symbolPosition = Number.parseInt(client.symbolPosition);
    console.log({facPrice: client.factoryPrice})
    // TODO: Replace client.symbol with entity code &euro;, etc. 
    client.symbol = client.symbol.replace('€','&euro;')
    client.factoryPrice = typeof(client.factoryPrice) === 'string' ? 
                                Number(client.factoryPrice.replace(',', '.')) :
                                client.factoryPrice

    try {
      loading.newLoading()
      const res = await apiSave(client);
      if (res.status === true)
        alert.newAlert({
          type: "successful",
          message: $_("rate_alert_save"),
          timeOut: 5000,
        })
        else {
        alert.newAlert({
          type: "error",
          message: $_("rate_alert_error"),
          timeOut: 5000,
        })
        console.error("Reason error: " + res.message);
      }
    } catch (error) {
      alert.newAlert({ 
        type: "error", 
        message: $_("rate_alert_error"), 
        timeOut: 5000 
      })
      console.error(error);
    } finally {
      loading.removeLoading()
    }
  };

  let infoRates = false;

  let linksHeader = $settingsHeaderLinksStore;
</script>

<HeaderHome links={linksHeader}/>
<HeaderCurrentClientInfo customText={$_("header_rateCurrentClientText")} />

<div class="container">
  <h4>
    {$_("rate_value")}<span
      on:click={() => (infoRates = !infoRates)}
      on:keypress={() => (infoRates = !infoRates)}
      style="cursor: pointer">+info</span
    >
  </h4>
  {#if infoRates}
    <section transition:slide id="info-section">
      <img
        id="close-info"
        on:click={() => (infoRates = false)}
        on:keypress={() => (infoRates = false)}
        alt="close"
        src="/icons/x-lg.svg"
      />
      <p>{$_("rate_informativeText")}</p>
      <p>{$_("rate_infoPointPvp")}{pointPvp}</p>
    </section>
  {/if}

  <form on:submit|preventDefault={saveRate} autocomplete="off">
    <ul class="flex-outer">
      <li class="preset-format">
        <label for="predef">{$_("rate_defaultFormats")}</label>
        <div class="btn-group">
          {#each Object.keys(regions) as reg}
            <button
              class="btn-3d second"
              class:active={region === reg}
              id={reg}
              on:click={changeRegion(reg)}
              type="button">{$_(`rate_regions_${reg}`)}</button
            >
          {/each}
        </div>
      </li>
      <li>
        <div class="label-input">
          <label for="point-value" id="point-value-label">{$_("rate_pointValue")}:</label>
          <input
            id="point-value"
            type="text"
            bind:value={factoryPrice}
            pattern="[0-9]+[.,]?[0-9]{'{0,3}'}"
            title={$_("rate_errorPointValue")}
            required
          />
        </div>
        <div class="label-input">
          <label for="symbol">{$_("rate_symbolCoin")}:</label>
          <input
            id="symbol"
            name="name"
            type="text"
            bind:value={symbol}
            minlength="1"
            maxlength="5"
            required
          />
        </div>
      </li>

      <li>
        <div class="label-input">
          <label for="separator">{$_("rate_thousandSepataror")}:</label>
          <select name="separator" id="separator" bind:value={separator}>
            <option value=".">.</option>
            <option value=",">,</option>
          </select>
        </div>
        <div class="label-input">
          <label for="position">{$_("rate_symbolPosition")}:</label>
          <select name="position" id="position" bind:value={symbolPosition}>
            <option value="0">{$_("rate_positions_left")}</option>
            <option value="1">{$_("rate_positions_right")}</option>
          </select>
        </div>
      </li>

      <label for="previa" id="previa-label">{$_("rate_previousView")}</label>
      <li class="previa">
        <div class="previa-input">
          <div class="label-input">
            <input
              type="number"
              id="previa"
              bind:value={previa}
              minlength="1"
              min="0"
            />
          </div>
          <div class="label-input">
            <span
              >{price2string({
                price: Number.parseFloat(previa ?? 0) * factoryPrice,
                ...client,
              })}</span
            >
          </div>
        </div>
      </li>
      <li>
        <button type="submit" class="btn-3d second" id="button-save"
          >{$_("rate_buttonSave")}</button
        >
      </li>
    </ul>
  </form>
</div>

<svelte:head>
  <link rel="stylesheet" href="/styles/pages/rates.css" />
</svelte:head>

<style>
</style>
